export const eventTypes = {
    CLICK: 'CLICK',
    VIEW: 'VIEW',
    DOWNLOAD : "DOWNLOAD"
  };
  